import { TextField, TextFieldProps } from "@mui/material";
import RegisterField, { FieldProps } from "../register-field";

export default function FormTextField({
    name,
    registerOptions,
    ...props
}: FieldProps<TextFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <TextField
            {...props}

            inputRef={field.ref}
            value={field.value == null ? "" : field.value}
            disabled={field.disabled}

            onChange={e => {
                field.handleChange(e.target.value);
                props.onChange && props.onChange(e);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}